// Shared audio upload options used across episode and content insertion flows.
// Keeping these centralized prevents modern/legacy drift in allowed file types.
export const AUDIO_ALLOWED_FILE_TYPES = [".MP3", ".WAV", ".M4A"];
export const AUDIO_ALLOWED_FILE_TYPES_MESSAGE =
  "You can only upload audio files (mp3, wav, m4a)";
